// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_oz-0";
export var animationContainer = "_oz-1";
export var itemPrice = "_oz-a";
export var itemizedContent = "_oz-9";
export var itemizedHeader = "_oz-7";
export var itemizedRow = "_oz-8";
export var itemizedSection = "_oz-6";
export var modalContent = "_oz-2";
export var orderName = "_oz-3";
export var refundOption = "_oz-4";
export var refundOptionsContainer = "_oz-5";
export var shippingLabel = "_oz-b";
export var totalRow = "_oz-c";